"use client";

import * as React from "react";
import { useEffect, useState } from "react";
import useFuzzySearchInjection, {
    TemplateProperty,
} from "~/hooks/useFuzzySearchInjection";
import { cn } from "~/utils/fontsConfig";

export interface TextareaProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, ...props }, ref) => {
        const inputStyles = cn(
            "focus-visible:ring-ring",
            "flex",
            "h-[40px]",
            "w-full",
            "rounded-md",
            "border",
            "border-v3-N-500",
            "bg-v3-N-500",
            "px-3",
            "py-2",
            "text-sm",
            "ring-offset-v2-foreground",
            "file:border-0",
            "file:bg-transparent",
            "file:text-sm",
            "file:font-medium",
            "overflow-scroll",

            "hover:border-v3-N-400",
            "hover:border-[1px]",

            "text-v3-N-200",
            "placeholder:text-v3-N-400 placeholder:italic",

            "focus-visible:outline-none",
            "focus-visible:ring-1",
            "focus-visible:ring-offset-1",
            "focus-visible:ring-white",

            "disabled:cursor-not-allowed",
            "disabled:opacity-50",
            "[&::-webkit-resizer]:bg-v3-N-500",
            className,
        );

        return (
            <div className="relative flex h-auto w-auto min-w-[0] flex-row items-center">
                <div className="flex w-full flex-col">
                    <textarea className={inputStyles} ref={ref} {...props} />
                </div>
            </div>
        );
    },
);
TextArea.displayName = "Textarea";

export { TextArea };
